"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = InlineEstimateInput;
const react_1 = __importStar(require("react"));
const ScrumboardApi_1 = __importDefault(require("../ScrumboardApi"));
/** Inline-edycja szacowanej liczby godzin. Klik → input; Enter/blur → zapis. */
function InlineEstimateInput({ task, onSaved }) {
    const [editing, setEditing] = (0, react_1.useState)(false);
    const [value, setValue] = (0, react_1.useState)(task.estimatedHours != null ? String(task.estimatedHours) : "");
    const [saving, setSaving] = (0, react_1.useState)(false);
    async function save() {
        setEditing(false);
        const parsed = value.trim() === "" ? null : Number(value);
        if (parsed != null && (Number.isNaN(parsed) || parsed < 0))
            return;
        if (parsed === (task.estimatedHours ?? null))
            return;
        try {
            setSaving(true);
            const result = await ScrumboardApi_1.default.updateTaskHours(task.id, { estimatedHours: parsed });
            onSaved({ estimatedHours: result.estimatedHours });
        }
        catch (err) {
            console.error("Błąd zapisu szac. czasu:", err);
        }
        finally {
            setSaving(false);
        }
    }
    if (!editing) {
        return (react_1.default.createElement("span", { className: "scrum-inline-value", title: "Kliknij, aby edytowa\u0107 szac. czas", onClick: (e) => {
                e.stopPropagation();
                setEditing(true);
            } },
            task.estimatedHours != null ? `${task.estimatedHours} h` : "—",
            saving && " …"));
    }
    return (react_1.default.createElement("input", { type: "number", min: 0, step: 0.25, autoFocus: true, className: "form-control form-control-sm scrum-inline-input", value: value, onClick: (e) => e.stopPropagation(), onChange: (e) => setValue(e.target.value), onBlur: save, onKeyDown: (e) => {
            if (e.key === "Enter")
                save();
            if (e.key === "Escape")
                setEditing(false);
        } }));
}
